/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/
import { BaseService, HttpResponse } from '../../service/base';
import { EventDataResultDTO } from '../../service/event_service';
import { DiagnosticDTO } from '../fleet_tab/service';

//-------------------------------------------------------------------------------------------------
// DTO Objects
//-------------------------------------------------------------------------------------------------
export interface GraderDTO {
    id: string;
    name: string;
    totalDistance: number;
    gradedDistance: number;
}

export interface GradingDTO {
    assetId: string;
    latitude: number;
    longitude: number;
    timestamp: number;
    input1: boolean;
    input2: boolean;
    input3: boolean;
    input4: boolean;
}

export interface GradingResultDTO {
    id: string;
    name: string;
    odometer: number;
}

export interface GradingDashboardDTO {
    totalKm: number;
}

export interface GradingEventDTO {
    assetId: string;
    eventId: string;
    geoJson: string;
    start: number;
    stop: number;
}

//-------------------------------------------------------------------------------------------------

/** Main service class that handles calls to the server and caches data
 * where it can.
 *
 */
export class GradingService extends BaseService {
    /** Call to get the grader information for a time period
     *
     * @param startUTC Start time for query
     * @param endUTC End time for query
     * @returns Promise with the requested info.
     */
    async getGraders(startUTC: number, endUTC: number): Promise<HttpResponse<DiagnosticDTO[]>> {
        const response = await this.get<DiagnosticDTO[]>(this.url + '/api/' + this.orgid + '/grader/info?start=' + startUTC + '&end=' + endUTC);
        return response;
    }

    async getDailyData(startUTC: number, endUTC: number) {
        const response = await this.get<EventDataResultDTO[]>(this.url + '/api/' + this.orgid + '/grader/dailydata?start=' + startUTC + '&end=' + endUTC);
        return response;
    }

    async getEvents(assetid: string, startUTC: number, endUTC: number) {
        const response = await this.get<GradingEventDTO[]>(this.url + '/api/' + this.orgid + '/event/grader?assetid=' + assetid + '&start=' + startUTC + '&end=' + endUTC);
        return response;
    }

    /*
    async getGradingReport(startUTC: number, endUTC: number) {
        var path = this.url + "/api/" + this.orgid + "/report/grader/?start="+startUTC + "&end=" + endUTC;
        return await this.http<any>(new Request(path, {method: "get", headers: this.streamheaders()}));
    }
    
    async getGrading(startUTC: number, endUTC: number) : Promise<HttpResponse<GradingDTO[]>>{
            let response =  await this.get<Array<GradingDTO>>(
            this.url + "/api/" + this.orgid + "/grader/data?start="+startUTC + "&end=" + endUTC
        );
        return response;
    }
    
    
    async getGradingDashboard(startUTC: number, endUTC: number) : Promise<HttpResponse<GradingDashboardDTO>>{
        let response =  await this.get<GradingDashboardDTO>(
            this.url + "/api/" + this.orgid + "/grader/dashboard/data?start="+startUTC + "&end=" + endUTC
        );
        return response;
    }


    async getResults(startUTC: string, endUTC: string) : Promise<HttpResponse<GradingResultDTO[]>> {
        let response =  await this.get<Array<GradingResultDTO>>(
            this.url + "/api/" + this.orgid + "/grader/results?start="+startUTC + "&end=" + endUTC
        );
        return response;
    }    
    */
}
